<template>
  <div class="wrapper-up">
    <div class="wrapper">
      <TheHeader
        :show-logo-menu="showLogoMenu"
        @isCloseUserAvatar="isShowOrNotShowUserAvatar"
        :showMenu="showMenu"
        @showMenu="changeShowMenu"
      />
      <TheSidebarOld @showMenu="changeShowMenu" />
      <main
        class="main main--tablet"
        :class="[
          {
            main__sidebar_opened:
              showSidebar && $route.path.split('/')[1] !== 'security'
          },
          { 'main--moved-xl': getDayRecordPanel },
          { mobile: isMobile },
          { 'main--moved': showMenu },
          {
            'main—move-locked':
              showMenu && $route.path.split('/')[1] === 'security'
          }
        ]"
        @click="
          () => {
            isCloseUserAvatar();
            isCloseDropDownList();
          }
        "
      >
        <!--        Content        -->
        <slot />
      </main>
      <TheFooter />
    </div>
    <TheBottomMenu />
  </div>
</template>
<script>
import TheHeader from './TheHeader';
import TheSidebarOld from '@/Components/Layout/TheSidebarOld';
import TheFooter from './TheFooter';
import TheBottomMenu from './TheBottomMenu';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'LayoutDefault',
  components: { TheBottomMenu, TheFooter, TheSidebarOld, TheHeader },
  data() {
    return {
      showLogoMenu: false,
      showMenu: false
    };
  },
  computed: {
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    ...mapGetters({
      getDayRecordPanel: 'studyCenter/getDayRecordPanel',
      getisDropDownActiveOne: 'managementList/getisDropDownActiveOne',
      getisDropDownActiveTwo: 'managementList/getisDropDownActiveTwo'
    }),
    showSidebar() {
      return this.$store.getters['front/getSidebarStatus'];
    },
    isStudent() {
      return this.$store.getters['auth/user'].entity_id === 2;
    }
  },
  mounted() {
    this.showMenu = localStorage.getItem('showMenu') === 'true' ? true : false;
  },
  methods: {
    parse(type) {
      return typeof type == 'string' ? JSON.parse(type) : type;
    },
    ...mapActions({
      management_list_updated: 'managementList/management_list_updated',
      management_list_updated_isDropDownActiveOne:
        'managementList/management_list_updated_isDropDownActiveOne',
      management_list_updated_isDropDownActiveTwo:
        'managementList/management_list_updated_isDropDownActiveTwo',
      setSidebarStatus: 'front/setSidebarStatus'
    }),
    changeShowMenu(menu) {
      localStorage.setItem('showMenu', menu);

      this.showMenu = menu;
    },
    isShowOrNotShowUserAvatar(prop) {
      this.showLogoMenu = prop;
    },
    isCloseUserAvatar() {
      this.showLogoMenu = false;
    },
    isCloseDropDownList() {
      this.management_list_updated_isDropDownActiveOne(false);
      this.management_list_updated_isDropDownActiveTwo(false);
      this.management_list_updated(false);
    }
  }
};
</script>
